var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFiltro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b9bbc4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.41,16.16v-5.75c0-2.62-1.13-3.54-2.43-4.61C1.92,4.94,.72,3.95,.37,2.01l-.15-.81H15.91l-.15,.8c-.38,2.11-1.42,3-2.34,3.78-1.07,.92-2,1.71-2,4.63v2.66l-6.01,3.09ZM1.95,2.57c.39,.94,1.1,1.53,1.9,2.18,1.37,1.12,2.93,2.4,2.93,5.67v3.51l3.28-1.68v-1.82c0-3.56,1.32-4.68,2.48-5.67,.69-.59,1.31-1.12,1.67-2.18H1.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFiltro);
export default __webpack_public_path__ + "static/media/icon_filtro.ffc58570029508a8c40b681774d184a0.svg";
export { ForwardRef as ReactComponent };